// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3n_Ed","inputWrap":"styles_inputWrap__2wGP3","input":"styles_input__3-uhb"};